import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ items = [] }) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ul className="breadcrumb__list">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (

            <li key={i} className="breadcrumb-item">
              {item.to && !isLast
                ? <Link to={item.to}>{item.label}</Link>
                : <span className={isLast ? "breadcrumb-current" : ""}>{item.label}</span>}
              {!isLast && <span className="breadcrumb-sep">/</span>}
            </li>

          );
        })}
      </ul>
    </nav>
  );
}